import { SettingsRepository } from "../repositories/SettingsRepository";
import { VerificationLivenessSession } from "../entities/VerificationUploadResult";

export class CreateAdminLiveFaceSession {
	constructor(private repository: SettingsRepository) {}

	execute(): Promise<VerificationLivenessSession> {
		return this.repository.createAdminLiveFaceSession();
	}
}
